import { useState, useEffect } from 'react';

const fmt = v => {
  if (v === '' || v === undefined || v === null || isNaN(Number(v))) return '';
  return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default function InputMoeda({ value, onChange, className, placeholder }) {
  const [display, setDisplay] = useState(fmt(value));

  useEffect(() => {
    setDisplay(fmt(value));
  }, [value]);

  const handleChange = e => {
    const digits = e.target.value.replace(/\D/g, '');
    if (digits === '') {
      setDisplay('');
      onChange('');
      return;
    }
    const num = Number(digits) / 100;
    setDisplay(fmt(num));
    onChange(num);
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      className={className}
      placeholder={placeholder ?? 'R$ 0,00'}
      value={display}
      onChange={handleChange}
    />
  );
}
